import type { TransactionsTableViewModel } from '@/features/billing/transactions/TransactionsTable/TransactionsTableViewModel'
import type { ActivationLifecycle } from '@/infra/activation'
import { LifecycleTracker } from '@/infra/lifecycle-tracker'
import type { SubmittedJob } from '@/features/jobs/details/SubmittedJob'

export class JobBillingDetailsViewModel implements ActivationLifecycle {
  private readonly _lifecycle = new LifecycleTracker()

  constructor(
    public readonly job: SubmittedJob,
    public transactionTableVm: TransactionsTableViewModel,
  ) {
    this._lifecycle.manage(transactionTableVm)
  }

  activate() {
    this._lifecycle.activate()
  }

  deactivate() {
    this._lifecycle.deactivate()
  }
}
